import { render, staticRenderFns } from "./emojipick.vue?vue&type=template&id=0c976088&scoped=true"
import script from "./emojipick.vue?vue&type=script&lang=js"
export * from "./emojipick.vue?vue&type=script&lang=js"
import style0 from "./emojipick.vue?vue&type=style&index=0&id=0c976088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c976088",
  null
  
)

export default component.exports